import dayjs from 'dayjs'
import { minio_url } from '../config/config'

export const get_nested = (keys, object, defaultValue = null, suffix = '') => {
  let res = keys.reduce((value, key) => value?.[key] ?? defaultValue, object)
  if (suffix && res !== defaultValue) res += suffix
  return res
}

export const set_nested_plain = (path, object, value) => {
  const keys = path.split('.')

  for (let index = 0; index < keys.length - 1; index++) {
    const key = keys[index]

    if (!object[key]) {
      object[key] = {}
    }

    object = object[key]
  }

  object[keys[keys.length - 1]] = value
}

export const get_nested_plain = (
  path,
  object,
  defaultValue = null,
  suffix = ''
) => {
  if (!path) {
    return null
  }

  return get_nested(
    path.replaceAll('[', '.').replaceAll(']', '').split('.'),
    object,
    defaultValue,
    suffix
  )
}

export const slugify = (str) => {
  str = str.replace(/^\s+|\s+$/g, '') // trim
  str = str.toLowerCase()

  // remove accents, swap ñ for n, etc
  var from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;'
  var to = 'aaaaeeeeiiiioooouuuunc------'

  for (let index = 0, l = from.length; index < l; index++) {
    str = str.replace(new RegExp(from.charAt(index), 'g'), to.charAt(index))
  }

  str = str
    .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-') // collapse dashes

  return str
}

export function formatPrice(
  number,
  isCents,
  defaultNum = '',
  forceCents = true
) {
  if (typeof number === undefined) {
    return defaultNum
  }

  let divider = 1

  if (isCents) {
    divider = 100
  }

  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: forceCents || (number / divider) % 1 !== 0 ? 2 : 0,
    minimumFractionDigits: forceCents || (number / divider) % 1 !== 0 ? 2 : 0,
  })
    .format(number / divider)
    .replaceAll(/\s/g, '')
}

export function getLastUpdate(date) {
  const currentDate = dayjs(new Date())
  const flowDate = dayjs(date)
  const diff = currentDate.diff(flowDate, 'second')

  if (diff < 60) {
    return 'quelques secondes'
  }

  if (diff < 3600) {
    return `${Math.floor(diff / 60)} min`
  }

  if (diff < 86400) {
    return `${Math.floor(diff / 3600)} h`
  } else {
    return `${Math.floor(diff / 86400)} jours`
  }
}

export const generateMinioUrl = (file) => {
  return [minio_url, file.bucketName, file.internalName].join('/')
}
